import { http } from './config'

export default {
  
  getAllOrderPriorities: () => {
    return http.get('order_priorities')
  },

  getFilteredOrderPriorities: (params) => {
    return http.get('order_priorities', {params})
  },

  getOrderPriorityById: (orderPriorityId) => {
    return http.get('order_priorities/' + orderPriorityId)
  },

  createOrderPriority: (orderPriorityParams) => {
    return http.post('order_priorities', {
      name: orderPriorityParams.name,
      level: orderPriorityParams.level
    }
  )},

  updateOrderPriority: (orderPriorityParams) => {
    return http.put('order_priorities/' + orderPriorityParams.id, {
      name: orderPriorityParams.name,
      level: orderPriorityParams.level
    }
  )},

  deleteOrderPriority: (orderPriorityId) => {
    return http.delete('order_priorities/' + orderPriorityId)
  },

}
